import React, { FC, InputHTMLAttributes } from 'react';
import classNames from 'classnames';
import { isPresent } from 'Shared/utils';
import { Label, LabelProps } from '../Text/Text';
import styles from './styles.module.css';

type InputProps = InputHTMLAttributes<HTMLTextAreaElement> &
  LabelProps & {
    errorMessage?: string;
    children?: React.ReactNode;
  };
export const TextArea: FC<InputProps> = ({
  label,
  errorMessage,
  tooltip,
  tooltipPosition,
  ...inputProps
}) => {
  const inputCss = classNames('fs-mask', styles.formControl, {
    [styles.hasError]: isPresent(errorMessage),
  });
  return (
    <div className={styles.container}>
      {[
        <Label
          key={`label-${inputProps.name}`}
          disabled={inputProps.disabled}
          tooltip={tooltip}
          tooltipPosition={tooltipPosition}
        >
          {label}
        </Label>,
        <textarea
          key={`textarea-${inputProps.name}`}
          className={inputCss}
          autoComplete="new-password"
          {...inputProps}
        ></textarea>,
      ]}
    </div>
  );
};
